var _rect, _path, _rect2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333,4a.833.833,0,0,1,.833.833v10h7.5a.833.833,0,0,1,0,1.667h-7.5a.833.833,0,0,1-.833-.833.833.833,0,0,1-.833-.833V5.667H4.833A.833.833,0,0,1,4.833,4Z",
    transform: "translate(-0.667 -0.667)",
    fill: "#5d78ff",
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.667,
    height: 6.667,
    rx: 3.333,
    transform: "translate(9.167 5.833)",
    fill: "#5d78ff",
    opacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(4.167 12.5)",
    fill: "#5d78ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default __webpack_public_path__ + "static/media/missing.3ed3f80afa4b191546ad9281d0ecc3a4.svg";
export { ForwardRef as ReactComponent };